import React, { useEffect, useState } from "react";
import { MdOutlineDelete } from "react-icons/md";
import { BsCheckCircleFill } from "react-icons/bs";
import { FaStar } from "react-icons/fa";
import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";
import { IoClose } from "react-icons/io5";
import { Empty, message, Rate, Spin } from "antd";
import { Button } from "react-bootstrap";
import { HiDownload } from "react-icons/hi";
import { API_URL } from "../API/config";
import axios from "axios";
import moment from "moment";

const style = {
  position: "absolute" as "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  bgcolor: "background.paper",
  boxShadow: 24,
  p: 4,
  borderRadius: "10px",
};

const styleD = {
  position: "absolute" as "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 700,
  bgcolor: "background.paper",
  boxShadow: 24,
  p: 4,
  borderRadius: "10px",
  height: "90%",
  overflowY: "scroll",
  scrollbarWidth: "none", 
  msOverflowStyle: "none", 
  "&::-webkit-scrollbar": {
    display: "none", 
  },
};

interface Variant {
  variantName: string;
  storage: string;
  colorCode: string;
  colorName: string;
  ramSize: string;
  price: number;
  _id: string;
}

interface CartItem {
  variant: Variant;
  product: string;
  price: number;
  DeliveryType: string;
  _id: string;
}

interface WishlistItem {
  variant: Variant;
  product: string;
  price: number;
  _id: string;
}

interface User {
  _id: string;
  email: string;
  role: string;
  cart: CartItem[];
  wishlist: WishlistItem[];
  __v: number;
  termscondition: boolean;
  passwordChangedAt: string;
  firstName: string;
  lastName: string;
  position: string;
  shippingAddress: {
    addressType: string;
    alternateNumber: string;
    buildingAndBlockNumber: string;
    email: string;
    firstName: "John";
    houseNumberAndFloor: string;
    landmark: string;
    lastName: string;
    locality: string;
    phoneNumber: string;
    pincode: string;
  };
  ExchangeType: string;
}

const CancelledOrder = () => {
  const [isDetail, setIsDetail] = useState(false);
  type ShippingAddress = {
    firstName: string;
    lastName: string;
    email: string;
    phoneNumber: string;
    houseNumberAndFloor: string;
    buildingAndBlockNumber: string;
    locality: string;
    landmark: string;
    pincode: string;
  };

  type Order = {
    _id: string;
    orderDate: string;
    paymentAmount: number;
    deliveryDate: string | null;
    paymentMethod: string;
    shippingAddress: ShippingAddress;
    products: Product[];
    exchange: boolean;
    deliveryType: string;
    productPrice: number;
    GSTInvoice: {
      isGSTEnabled: boolean;
    };
  };

  type Product = {
    id: string;
    name: string;
    quantity: number;
    price: number;
    productName: string;
    discountedPrice: number;
    colorName: string;
    storage: string;
    ramSize: string;
    productPrice: string;
    productImage:string
  };

  const [viewData, setViewData] = useState<Order | null>(null);

  const handleDetailOpen = (data: any) => {
    setViewData(data);
    setIsDetail(true);
  };
  const handleDetailClose = () => setIsDetail(false);
  const [data, setData] = useState<any[]>([]);
  const [userData, setUserData] = useState<User | null>(null);
  const [conformOrder, setConformOrder] = useState<any[]>([]);
  const [deliveredOrder, setDeliveredOrder] = useState<any[]>([]);
 
  const getUser = async () => {
    const token = sessionStorage.getItem("token");
       if(!token){
         message.error("Login required!") 
         return
       }

    try {
      const res = await axios.get(`${API_URL}/api/user/getMe`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      setUserData(res.data.user);
      await getOrders(res.data.user._id);
    } catch (error: any) {
      console.log(error);
    }
  };

  const getOrders = async (id: any) => {
    const token = sessionStorage.getItem("token");
 
    try {
      const res = await axios.get(`${API_URL}/api/orders/user/${id}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      setData(res.data.data.orders);
      const conformData = res.data.data.orders.filter(
        (val: any) =>
          val.status !== "completed" &&
          val.status !== "replaced" &&
          !val.isCancelled &&
          !val.replacedOrder
      );
      const completedData = res.data.data.orders.filter(
        (val: any) => val.isCancelled && !val.replacedOrder
      );
      // Fetch product details for completed orders
      const completedOrdersWithImages = await Promise.all(
        completedData.map(async (order: any) => {
          const productsWithImages = await Promise.all(
            order.products.map(async (product: any) => {
              if (product.productId) {
                try {
                  const productResponse = await axios.get(
                    `${API_URL}/api/products/getById/${product.productId}`
                  );
                  return {
                    ...product,
                    productImage: productResponse.data.variants[0].images[0], 
                  };
                } catch (err) {
                  console.warn(`Error fetching product image: ${err}`);
                  return { ...product, productImage: null }; 
                }
              } else {
                return { ...product, productImage: null }; 
              }
            })
          );
          return { ...order, products: productsWithImages };
        })
      );
      setConformOrder(conformData.reverse());
      setDeliveredOrder(completedOrdersWithImages.reverse());
    } catch (error) {
      console.log(error);
    }
  };



  useEffect(() => {
    getUser();
  }, []);


  // if(deliveredOrder.length===0){
  //   return <><div className="text-center"><Spin className="custom-spinner"/></div></>
  // }

  return (
    <>
      <section>
        {deliveredOrder.length > 0 ? (
          <div className="order-padd">
            {deliveredOrder.map((val, i) => (
              <div className="row py-2">
                <div className="col-lg-1 col-md-1 col-sm-3 col-3">
                  <div>
                    <img
                      className="img-fluid order-img"
                      src={val.products[0].productImage}
                    />
                  </div>
                </div>
                <div className="col-lg-3 col-md-3 col-sm-9 col-9">
                  <div>
                    <h3 className="order-head">
                      {val.products[0].productName || ""}{" "}
                      {`${val.products[0].ramSize || ""},${
                        val.products[0].storage || ""
                      },${val.products[0].colorName || ""}`}
                    </h3>
                  </div>
                </div>
                <div className="col-lg-3 col-md-3 d-flex justify-content-center">
                  <div className="order-price">
                    <p>₹ {val.paymentAmount.toFixed(2)}</p>
                    <span
                      style={{ textDecoration: "underline", cursor: "pointer" }}
                      onClick={() => handleDetailOpen(val)}
                    >
                      View detail
                    </span>
                  </div>
                </div>
                <div className="col-lg-5">
                  <div className="order-deliv">
                    <p>
                      Cancelled on{" "}
                      {moment(val.cancellationDate).format("ddd DD-MM-YYYY")}{" "}
                      <BsCheckCircleFill
                        className="ms-3 mb-1"
                        style={{ color: "#2FB300", fontSize: "20px" }}
                      />
                    </p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        ) : (
          <Empty description="No items found" />
        )}
      </section>

      {/* Detail model */}
      <Modal
        open={isDetail}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={styleD}>
          <div className="d-flex justify-content-between align-items-center">
            <h3 className="ratr-head">Order Detail</h3>
            {viewData?.GSTInvoice?.isGSTEnabled && (
              <div>
                <p>
                  GST Invoice
                  <HiDownload
                    className="me-3"
                    style={{ fontSize: "20px", cursor: "pointer" }}
                  />
                </p>
              </div>
            )}
            <IoClose
              style={{ fontSize: "20px", cursor: "pointer" }}
              onClick={handleDetailClose}
            />
          </div>
          {viewData && (
            <>
              <div className="row pt-4">
                <div className="col-lg-8 col-md-8 col-sm-12 col-12">
                  <div className="detail-s py-2">
                    <h5>Shipping Detail</h5>
                    <p>
                      <span>
                        {`${viewData.shippingAddress.firstName} ${viewData.shippingAddress.lastName}`}
                      </span>
                      , {viewData.shippingAddress.email},{" "}
                      {viewData.shippingAddress.phoneNumber}
                    </p>
                    <p>
                      {[
                        viewData.shippingAddress.houseNumberAndFloor,
                        viewData.shippingAddress.buildingAndBlockNumber,
                        viewData.shippingAddress.locality,
                        viewData.shippingAddress.landmark,
                        viewData.shippingAddress.pincode,
                      ]
                        .filter(Boolean)
                        .join(", ")}
                    </p>
                  </div>
                </div>
                <div className="col-lg-4 col-md-4 col-sm-12 col-12">
                  <div className="detaisl-order py-2">
                    <h5>Order Detail</h5>
                    <p>
                      <span>Order date:</span>{" "}
                      {moment(viewData.orderDate).format("DD-MM-YYYY")}
                    </p>
                    <p>
                      <span>Order ID:</span> {viewData._id.slice(-5) || "-"}
                    </p>
                    <p>
                      <span>Order total:</span> ₹{" "}
                      {viewData.paymentAmount || "-"}
                    </p>
                    <p>
                      <span>Delivered on:</span>{" "}
                      {viewData.deliveryDate
                        ? moment(viewData.deliveryDate).format("DD-MM-YYYY")
                        : "-"}
                    </p>
                    <p>
                      <span>Payment:</span> {viewData.paymentMethod || "-"}
                    </p>
                  </div>
                </div>
              </div>
              {viewData.products.map((product, index) => (
                <div key={index} className="row orer-q pt-4">
                  <div className="col-lg-4 col-md-4 col-sm-6 col-6">
                    <div className="text-start">
                      <img className="img-fluid" src={product.productImage} />
                      <p className="ps-3">Qt: {product.quantity || 1}</p>
                    </div>
                  </div>
                  <div className="col-lg-4 col-md-4 col-sm-6 col-6">
                    <div>
                      <h3>{`${
                        product.productName ? product.productName : ""
                      } (${product.ramSize ? product.ramSize : ""}${
                        product.storage ? "," + product.storage : ""
                      } ${
                        product.colorName ? "," + product.colorName : ""
                      })`}</h3>
                    </div>
                  </div>
                  <div className="col-lg-4 col-md-4 col-sm-12 col-12">
                    <div>
                      <h3>₹ {product.productPrice || ""}</h3>
                      <p>
                        {viewData.deliveryType === "Express"
                          ? "Express delivery"
                          : "Standard delivery"}{" "}
                        with{" "}
                        {viewData.exchange ? "exchange" : "with out exchange"}
                      </p>
                    </div>
                  </div>
                </div>
              ))}
            </>
          )}
        </Box>
      </Modal>
    </>
  );
};

export default CancelledOrder;
